const getSession = async () => {
  const response = await fetch(
    '/api/session',
    {
      method: 'get',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    },
  );
  const data = await response.json();
  return data;
};
export default getSession;



// WEBPACK FOOTER //
// ./src/actions/session.js